export default "__VITE_ASSET__5d12aa33__"